import { biLogger } from '#packages/util';
import {
  aiAssistantActionClick,
  aiAssistantWidgetLoadedSrc38Evid2102,
} from '@wix/bi-logger-editor-data/v2';

import type { ChatMessageData } from '@wix/chat-widget-ui-lib';
import type { WidgetAction, WidgetData } from './aiAssistantTypes';

import { ACTIONS } from './widgets/constants';

export const getWidgetMessage = ({
  role,
  widget,
  data,
}: WidgetData): ChatMessageData => {
  return {
    role,
    content: `<<{"widget": "${widget}", "data": ${JSON.stringify(data)}}>>`,
  };
};

export const biWidgetActionMapper = ({
  assistantName,
  origin,
  widgetName,
  data,
}: WidgetAction) => ({
  [ACTIONS.WIDGET_LOAD]: () => {
    biLogger.report(
      aiAssistantWidgetLoadedSrc38Evid2102({
        target: assistantName,
        origin,
        widgetName,
      }),
    );
  },
  [ACTIONS.BUTTON_CLICK]: () => {
    biLogger.report(
      aiAssistantActionClick({
        actionGroup: assistantName,
        actionName: data.value,
        widgetName,
      }),
    );
  },
});

export const getUserMessageCount = (messages: ChatMessageData[]): number =>
  messages.filter(({ role }: ChatMessageData) => role === 'user').length;
